import { ReactNode } from 'react'

interface StatItem {
  label: string
  value: ReactNode
}

interface StatsCardProps {
  stats: StatItem[]
}

export function StatsCard({ stats }: StatsCardProps) {
  return (
    <div className="space-y-2 overflow-x-hidden">
      {stats.map((stat, index) => (
        <div key={index} className="flex justify-between items-center h-[24px]">
          <div className="text-xs font-medium text-gray-900">{stat.label}</div>
          <div className="text-xs font-light text-gray-900 text-right">
            {stat.value}
          </div>
        </div>
      ))}
    </div>
  )
}
